import { createRouter, createWebHistory } from 'vue-router'

import { validateSession } from '../middleware/middleware'
import {
  AboutusPage,
  AppDevelopmentPage,
  ClientsPage,
  ContactPage,
  DigitalMarKetingPage,
  LandingPage,
  OfflineMarKetingPage,
  SocialMediaPage,
  TermsPage,
  WebDevelopmentPage,
} from './pages'

const PublicFunnelView = () => import('./views/PublicFunnelView.vue')
const AdminLoginView = () => import('./views/AdminLoginView.vue')
const AdminLayoutView = () => import('./views/AdminLayoutView.vue')
const AdminDashboardView = () => import('./views/AdminDashboardView.vue')
const AdminFormsView = () => import('./views/AdminFormsView.vue')
const AdminFormEditView = () => import('./views/AdminFormEditView.vue')
const AdminLeadsView = () => import('./views/AdminLeadsView.vue')
const AdminLeadDetailView = () => import('./views/AdminLeadDetailView.vue')
const AdminCalendarView = () => import('./views/AdminCalendarView.vue')
const AdminReportsView = () => import('./views/AdminReportsView.vue')
const AdminCalendarCallbackView = () => import('./views/AdminCalendarCallbackView.vue')

const routes = [
  { path: '/', name: 'LandingPage', component: LandingPage },
  { path: '/services/digital-marketing', name: 'DigitalMarKetingPage', component: DigitalMarKetingPage },
  { path: '/services/web-development', name: 'WebDevelopmentPage', component: WebDevelopmentPage },
  { path: '/services/social-media', name: 'SocialMediaPage', component: SocialMediaPage },
  { path: '/services/offline-marketing', name: 'OfflineMarKetingPage', component: OfflineMarKetingPage },
  { path: '/services/app-development', name: 'AppDevelopmentPage', component: AppDevelopmentPage },
  { path: '/aboutus', name: 'AboutusPage', component: AboutusPage },
  { path: '/clients', name: 'ClientsPage', component: ClientsPage },
  { path: '/contact', name: 'ContactPage', component: ContactPage },
  { path: '/terms', name: 'TermsPage', component: TermsPage },
  { path: '/forms/:slug', name: 'PublicFunnel', component: PublicFunnelView },
  { path: '/admin/login', name: 'AdminLogin', component: AdminLoginView },
  { path: '/admin/calendar/callback', name: 'AdminCalendarCallback', component: AdminCalendarCallbackView, meta: { requiresAuth: true } },
  {
    path: '/admin',
    component: AdminLayoutView,
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'AdminDashboard', component: AdminDashboardView },
      { path: 'forms', name: 'AdminForms', component: AdminFormsView },
      { path: 'forms/:id', name: 'AdminFormEdit', component: AdminFormEditView },
      { path: 'leads', name: 'AdminLeads', component: AdminLeadsView },
      { path: 'leads/:id', name: 'AdminLeadDetail', component: AdminLeadDetailView },
      { path: 'calendar', name: 'AdminCalendar', component: AdminCalendarView },
      { path: 'reports', name: 'AdminReports', component: AdminReportsView },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.path === '/admin/login' && sessionStorage.getItem('adminToken')) {
    const isAuthenticated = await validateSession()
    if (isAuthenticated) {
      next('/admin')
      return
    }
  }

  if (!to.matched.some((route) => route.meta.requiresAuth)) {
    next()
    return
  }

  const isAuthenticated = await validateSession()
  if (!isAuthenticated) {
    next({ path: '/admin/login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

export default router

